import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function Pool() {
  const { i18n } = useTranslation('offer-package');

  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (i18n.language === 'de') {
    return (
      <div className="bg-white grid md:grid-cols-2">
        <div className="bg-[#2ca67a] print:bg-white px-4 py-5 flex items-center">
          <div className="flex flex-col items-start gap-8 md:ml-10 lg:ml-20 py-10">
            {!isOpen && (
              <Fragment>
                <p className="text-white uppercase print:text-black flex flex-col text-4xl space-y-2 font-light">
                  <span>Hoteleigene</span>
                  <span className="font-medium">Thermal-Heilquelle</span>
                </p>

                <button
                  type="button"
                  className="uppercase text-white py-4 px-6 border-white border-2"
                  onClick={() => setIsOpen(true)}
                >
                  Mehr erfahren
                </button>
              </Fragment>
            )}

            {isOpen && (
              <Fragment>
                <button
                  type="button"
                  className="uppercase text-white bg-[#155f4f] px-5 py-3 flex gap-2 items-center"
                  onClick={() => setIsOpen(false)}
                >
                  <ArrowLeftIcon className="size-6" /> zurück
                </button>

                <div className="text-white">
                  <ul className="list list-disc ms-5">
                    <li>Heilthermal-Panoramapool 32 °C</li>
                    <li>Außenpool 28 °C</li>
                  </ul>
                </div>
              </Fragment>
            )}
          </div>
        </div>

        <div className="w-full h-full max-h-140">
          <img
            src="https://cdn.mandira-ayurveda.at/images/resort/2020/pool.jpg"
            alt="Spa"
            className="w-full h-full object-cover"
          ></img>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white grid md:grid-cols-2">
      <div className="bg-[#2ca67a] print:bg-white px-4 py-5 flex items-center">
        <div className="flex flex-col items-start gap-8 md:ml-10 lg:ml-20 py-10">
          {!isOpen && (
            <Fragment>
              <p className="text-white uppercase print:text-black flex flex-col text-4xl space-y-2 font-light">
                <span>Hotel's own</span>
                <span className="font-medium">Thermal healing spring</span>
              </p>

              <button
                type="button"
                className="uppercase text-white py-4 px-6 border-white border-2"
                onClick={() => setIsOpen(true)}
              >
                Learn more
              </button>
            </Fragment>
          )}

          {isOpen && (
            <Fragment>
              <button
                type="button"
                className="uppercase text-white bg-[#155f4f] px-5 py-3 flex gap-2 items-center"
                onClick={() => setIsOpen(false)}
              >
                <ArrowLeftIcon className="size-6" /> go back
              </button>

              <div className="text-white">
                <ul className="list list-disc ms-5">
                  <li>Healing thermal panorama pool 32 °C</li>
                  <li>Outdoor pool 28 °C</li>
                </ul>
              </div>
            </Fragment>
          )}
        </div>
      </div>

      <div className="w-full h-full max-h-140">
        <img
          src="https://cdn.mandira-ayurveda.at/images/resort/2020/pool.jpg"
          alt="Spa"
          className="w-full h-full object-cover"
        ></img>
      </div>
    </div>
  );
}

export default Pool;
